/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Period_ApplyInputs */

const cs_dashboard_period_apply = /** @type {(inputs: Dashboard_Period_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít`)
};

const en_dashboard_period_apply = /** @type {(inputs: Dashboard_Period_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Dashboard_Period_ApplyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_period_apply = /** @type {((inputs?: Dashboard_Period_ApplyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Period_ApplyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_period_apply(inputs)
	return cs_dashboard_period_apply(inputs)
});